/** Legacy path. The primitive lives in `@/components/ui/card` (DESIGN.md §6). */
export { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter, Section } from '@/components/ui/card';

export type { CardProps } from '@/components/ui/card';
